import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store third party players data
    endpoint: endpoints.third_party_player.endpoint, // "third-party-player",
    thirdPartyPlayers: [],
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the third party players data
    endpoint: state => state.endpoint,
    thirdPartyPlayers: state => state.thirdPartyPlayers,
    thirdPartyPlayerByID: state => id => { // COMMENT-OUT IF ULTIMATELY NOT NEEDED
      for (const thirdPartyPlayer of state.thirdPartyPlayers) {
        if (thirdPartyPlayer.eid === id) return thirdPartyPlayer;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.THIRD_PARTY_PLAYERS_LOAD](state, thirdPartyPlayers) {
      state.thirdPartyPlayers = JSON.parse(JSON.stringify(thirdPartyPlayers));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetchByIDs: (context, paginationData) => {
      const ids = paginationData.ids;
      if (typeof ids === 'undefined') {
        console.error("third-party-player/fetchByIDs ids is undefined");
        return
      }
      const api = context.rootGetters['global/apiUrl'] + '/' + context.state.endpoint + '/' + ids.join(',') + ',';

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          params: {
            fields: paginationData.fields
          },
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.objects == null) r.data.objects = {}
              context.commit(types.THIRD_PARTY_PLAYERS_LOAD, r.data.objects);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s"; // UNCOMMENT AFTER BACKEND UPDATE
      //const api = context.rootGetters['global/apiUrl'] + "/" + "player" + "s";       // TESTING ONLY

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
              context.commit(types.THIRD_PARTY_PLAYERS_LOAD, r.data.rows);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id; // UNCOMMENT AFTER BACKEND UPDATE
      //const api = context.rootGetters['global/apiUrl'] + "/" + "player" + "/" + id;     // TESTING ONLY

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    update: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.eid; // UNCOMMENT AFTER BACKEND UPDATE
      //const api = context.rootGetters['global/apiUrl'] + "/" + "player" + "/" + data.eid;     // TESTING ONLY

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },


    /*
    create: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
            url: api,
            data: data,
            method: 'POST'
          })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    */

    /*
    delete: (context, ids) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/deleteById";

      return new Promise((resolve, reject) => {
        axios({
            url: api,
            data: {
              ids
            },
            method: 'POST'
          })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    */

    /*
    bulkAction: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/bulkAction";

      return new Promise((resolve, reject) => {
        axios({
            url: api,
            data,
            method: 'POST'
          })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    */

  }
};
